export default "__VITE_ASSET__DYSkPpwJ__"